import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Category from '@shared/models/category.model';
import { Product } from '@shared/models/product.model';
import { NavigationService } from '@shared/services/navigation.service';
import { SessionStoreService } from '@shared/services/session-store.service';
import { CustomCookieService } from '@shared/services/cookie.service';
import { ProductsService } from '@shared/services/products.service';
import { ProductSkuFilterRequest } from '@shared/models/request/product-sku-filter-request';
import { getRandomInt } from '@shared/helpers/util';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {

  product: Product

  crossSaleProducts: Product[] = []

  selectedImageIndex: number = 0;

  selectedColorIndex: number = 0;

  category: Category

  recentlyViewProducts: Product[] = []


  breadcrumb: Category[] = []

  categoryIdParam: number;

  constructor(private productService: ProductsService, private cdf: ChangeDetectorRef, private route: ActivatedRoute, private ss: SessionStoreService, private navigationService: NavigationService, private cookieService: CustomCookieService) { }

  ngOnInit(): void {
    
    this.route.paramMap.subscribe(params => {
      this.categoryIdParam = +params.get('categoryId')
    })

    this.route.data.subscribe((data: { product: any }) => {
      this.product = data.product
      this.cdf.detectChanges()
      this.cookieService.addRecentViewedProducts(this.product)

      //Get Cross Sale Product
      this.productService.getCrossSaleProduct(this.product.id).subscribe(crossSaleProducts => {
        this.crossSaleProducts = crossSaleProducts
        //If no cross sale, get product by random cat
        if(this.crossSaleProducts.length <= 0) {
          const filter = new ProductSkuFilterRequest()
          const filteredCats = this.product.categories.filter(cat => cat.key !== "root")
          filter.categoryIds.push(filteredCats[getRandomInt(filteredCats.length)].id)
          this.productService.getProductList(0, 'id', "5", 'DESC', filter).subscribe(crossSaleProducts => {
            this.crossSaleProducts = crossSaleProducts.content.filter(prod => prod.id !== this.product.id)
          })
        }
      })

      //Set recent viewed product
      this.recentlyViewProducts = this.cookieService.getRecentViewedProducts().filter(prod => prod.id !== this.product.id)

      const list: Category[] = this.ss.getItem("categoryList")

      if(list && list.length > 0 && this.categoryIdParam !== 0) {
        //Create breadcrumb
        this.breadcrumb = []
        this.category = list.find(cat => cat.id === this.categoryIdParam)
        const parent = this.category.path.split("/")
        //Shift away the root category
        parent.shift()
        //Men or Women
        parent.map(key => {
          this.breadcrumb.push(list.find(cat => cat.key === key))
        })
      }
    })

    //For the first time load into product detail
    this.navigationService.categoryItems$.subscribe(list => {

      const sslist: Category[] = this.ss.getItem("categoryList")

      if(!sslist && list && list.length > 0 && this.categoryIdParam !== 0) {
          //Create breadcrumb
          this.breadcrumb = []
          this.category = list.find(cat => cat.id === this.categoryIdParam)
          const parent = this.category.path.split("/")
          //Shift away the root category
          parent.shift()
          //Men or Women
          parent.map(key => {
            this.breadcrumb.push(list.find(cat => cat.key === key))
          })
      }
    })

    
  }

  selectImage(index: number) {
    this.selectedImageIndex = index
  }

}
